<div class="card_status_actions">
  <div class="card_header">
    <h4>
      {{ "rights.statusAndActions" | translate }}
    </h4>
    <app-fraud-monitoring-tasks-status [status]="record.status"></app-fraud-monitoring-tasks-status>
  </div>
  <div class="card_body">
    <div class="container_no_action_needed border-0"
      *ngIf="availableActions.actions && !availableActions.actions.length && record.status && record.status.statusCode == taskStatus.Published;else noActions">
      <img src="assets/images/illu_request_closed.png" alt="">
      <p class="title_actions">
        {{ "fraudTasks.fraudMonitoringCasePublishedSuccessfully" | translate }}
      </p>
    </div>
    <ng-template #noActions>
      <div class="container_no_action_needed" [class.border-0]="!availableActions.actions.length"
        *ngIf="availableActions.actions && !availableActions.actions.length">
        <img src="assets/images/illu_no_action_needed.png" alt="">
        <p class="desc_actions">
          {{ "rights.noActionRequired" | translate }}
        </p>
      </div>
    </ng-template>

    <ng-container *ngIf="availableActions.messages && availableActions.messages.length">
      @for (item of availableActions.messages; track $index) {
      <img *ngIf="item.image" [src]="'assets/images/' + item.image" alt="">
      <p class="desc_actions">
        {{ item.message }}
      </p>
      }
      <hr class="divider_actions">
    </ng-container>

    <div class="wrapper_actions" *ngIf="record.publishedTaskName">
      <h6 class="title_wrapper_actions">
        {{ "fraudTasks.monitoredCaseName" | translate }}
      </h6>
      <p class="desc_wrapper_actions">
        {{record.publishedTaskName}}
      </p>
    </div>

    <div class="wrapper_actions mb-3" *ngIf="record.institution" [class.mt-3]="record.institution">
      <h6 class="title_wrapper_actions">
        {{ "verificationTasks.escalationAuthority" | translate }}
      </h6>
      <p class="desc_wrapper_actions">
        {{record.institution}}
      </p>
      <div class="divider_wrapper_actions"></div>
      <h6 class="title_wrapper_actions">
        {{ "verificationTasks.escalationReason" | translate }}
      </h6>
      <p class="desc_wrapper_actions"
        [innerText]="record.escalationReason?record.escalationReason:'general.none'|translate"></p>
    </div>

    @if (availableActions && availableActions.actions && availableActions.actions.length) {
    <p class="label_actions text-center">
      {{ "rights.availableActions" | translate }}
    </p>

    @for (action of availableActions.actions; track action.actionId){
    <button mat-raised-button type="button" [disabled]="loading" [class]="action.class" [class.loading]="loading"
      (click)="handleClick(action)">
      <span>{{action.title}}</span>
    </button>
    }
    }
  </div>
</div>